// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"57040049","289":"c4517abe","473":"d7ee8dc8","591":"64a50845"}[chunkId] + ".chunk.js";
};